import React, { useEffect, useMemo, useState } from "react";
import TableContainer from "../../components/Common/TableContainer";
import Breadcrumb from "../../components/Common/Breadcrumb";
import { Card, CardBody, Button, Container } from "reactstrap";
import { Link, useNavigate } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import { getRecords } from "../../services/api.service";
import { exportPageData } from "./InstallationApprovalFile";
import moment from "moment";

const breadcrumbItems = [];

const InstallationApprovalList = () => {
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [searchKeyword, setSearchKeyword] = useState("");
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [totalCount, setTotalCount] = useState(0);
  const [exportData, setExportData] = useState([]);

  useEffect(() => {
    const projectId = JSON.parse(localStorage.getItem("projectID"));
    const contractor_id = JSON.parse(localStorage.getItem("userDetails"))?.id;

    getData(projectId, contractor_id);
  }, [searchKeyword, page, pageSize]);
  useEffect(() => {
    const projectId = JSON.parse(localStorage?.getItem("projectID"));
    const contractor_id = JSON.parse(localStorage.getItem("userDetails"))?.id;

    handleExportData(projectId, contractor_id);
  }, []);
  const getData = async (Id, contractor_id) => {
    try {
      const payload = {
        modelName: "installations",
        whereCondition: {
          project_id: Id,
          assigned_to: contractor_id,
          is_active: true,
          status: "installation_completed",
        },
        relations: [
          {
            module: "projects",
            moduleAs: "projects",
          },
          {
            module: "installation_commissioning_list_masters",
            moduleAs: "installationCommissioning",
          },
        ],
        search: {
          searchKeyword: searchKeyword,
          field_name: [
            "field_name",
            "installationCommissioning.form_name",
            "installation_no",
            "projects.project_name",
          ],
        },
        pagination: {
          page: page + 1,
          pageSize: pageSize,
        },
      };
      const responseData = await getRecords(payload, "/getRecords");
      responseData.data.forEach((element, index) => {
        element.index = index + 1;
      });
      setTotalCount(responseData.count);

      const sortedData = responseData.data.sort((a, b) => b.index - a.index);
      setData(sortedData);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleClickAdd = () => {
    navigate("/outward-create");
  };

  const handleViewClick = (id) => {
    navigate(`/installation-approval-view/${id}`);
  };

  const getSearchInputData = (inputValue) => {
    setSearchKeyword(inputValue);
  };

  const nextToPages = () => {
    setPage(page + 1);
  };

  const previousToPages = () => {
    setPage(page - 1);
  };

  const handlePageSizeChange = (data) => {
    setPageSize(data);
    const newTotalPages = Math.ceil(totalCount / data);
    if (page >= newTotalPages) {
      setPage(0);
    }
  };

  const lastToPages = () => {
    setPage(Math.ceil(totalCount / pageSize) - 1);
  };

  const previousFirstToPages = () => {
    setPage(0);
  };

  const columns = useMemo(
    () => [
      {
        Header: "SR.NO",
        accessor: "index",
        accessor: (row) => page * pageSize + row.index,
        disableFilters: true,
        filterable: false,
        Cell: ({ value }) => <div style={{ width: "50px" }}>{value}</div>,
      },
      {
        Header: "PROJECT NAME",
        accessor: (row) =>
          row?.projects?.project_name ? row?.projects?.project_name : "-",
        disableFilters: true,
        filterable: false,
        Cell: ({ value }) => <div style={{ width: "150px" }}>{value}</div>,
      },
      {
        Header: "INSTALLATION NO",
        accessor: (row) =>
          row?.installation_no && row?.installation_no
            ? row?.installation_no
            : "-",
        disableFilters: true,
        filterable: false,
        Cell: ({ value }) => <div style={{ width: "150px" }}>{value}</div>,
      },

      {
        Header: "FORM NAME",
        accessor: (row) =>
          row?.installationCommissioning?.form_name &&
          row?.installationCommissioning?.form_name
            ? row?.installationCommissioning?.form_name
            : "-",
        disableFilters: true,
        filterable: false,
        Cell: ({ value }) => <div style={{ width: "150px" }}>{value}</div>,
      },

      {
        Header: "FIELD NAME",
        accessor: (row) => (row?.field_name ? row?.field_name : "-"),
        disableFilters: true,
        filterable: false,
        Cell: ({ value }) => <div style={{ width: "150px" }}>{value}</div>,
      },
      {
        Header: "INSTALLATION STATUS",
        accessor: (row) => (row?.status ? row.status : "-"),
        disableFilters: true,
        filterable: false,
        Cell: ({ value }) => {
          let statusClass = "";
          let statusText = "";

          switch (value) {
            case "installation_rejected":
              statusClass = "bg-danger-subtle text-danger";
              statusText = "Installation Rejected";
              break;
            case "installation_approved":
              statusClass = "bg-success-subtle text-success";
              statusText = "Installation Approved";
              break;
            case "installation_completed":
              statusClass = "bg-warning-subtle text-warning";
              statusText = "Installation Completed";
              break;
            default:
              statusClass = "bg-secondary-subtle text-secondary";
              statusText = value === "-" ? "No Status" : value;
              break;
          }

          return (
            <div style={{ width: "150px" }}>
              <span className={`badge ${statusClass} text-uppercase`}>
                {statusText}
              </span>
            </div>
          );
        },
      },
      {
        Header: "STATUS",
        accessor: "is_active",
        disableFilters: true,
        filterable: false,
        Cell: ({ value }) => (
          <div style={{ width: "100px" }}>
            {value === 0 ? (
              <span className="badge bg-danger-subtle text-danger text-uppercase">
                In-active
              </span>
            ) : (
              <span className="badge bg-success-subtle text-success text-uppercase">
                Active
              </span>
            )}
          </div>
        ),
      },
      {
        Header: "ACTION",
        accessor: "actions",
        disableFilters: true,
        filterable: false,
        Cell: ({ row }) => (
          <div style={{ width: "150px" }}>
            <div
              onClick={() => {
                handleViewClick(row.original.id);
              }}
            >
              <Link className="me-3 text-primary">
                <i className="mdi mdi-eye font-size-18"></i>
              </Link>
            </div>
          </div>
        ),
      },
    ],
    [page, pageSize]
  );

  const formatDate = (dateString) => {
    if (!dateString) return "-";
    const date = new Date(dateString);
    return date.toISOString().split("T")[0];
  };

  const handleExportData = async (projectId, contractor_id) => {
    try {
      // exportPageData.data.whereCondition = {
      //   type: "Scrab",
      //   project_id: projectId,
      //   contractor_id: contractor_id,
      // };
      const payload = {
        modelName: "installations",
        whereCondition: {
          project_id: projectId,
          assigned_to: contractor_id,
          is_active: true,
          status: "installation_completed",
        },
        relations: [
          {
            module: "projects",
            moduleAs: "projects",
          },
          {
            module: "installation_commissioning_list_masters",
            moduleAs: "installationCommissioning",
          },
        ],
        pagination: { page: 1, pageSize: 100000 },
      };

      const responseData = await getRecords(payload, "/getRecords");
      if (responseData?.data.length == 0) setExportData([]);
      const exportData = responseData?.data.map((item, index) => ({
        "SR. NO": index + 1,
        "Project Name": item?.projects?.project_name || "N/A",
        "INSTALLATION NO": item?.installation_no || "N/A",
        "FORM NAME": item?.installationCommissioning?.form_name || "N/A",
        "FIELD NAME": item?.field_name || "N/A",
        "INSTALLATION STATUS": item?.status || "N/A",
        STATUS:
          item?.is_active === false || item?.is_active === 0
            ? "In-active"
            : "Active",
      }));
      setExportData(exportData);
    } catch (error) {
      console.error("Error fetching records:", error);
    }
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              marginBottom: "10px",
            }}
          >
            <Breadcrumb
              title="Installation Approval List"
              breadcrumbItems={breadcrumbItems}
            />
            {/* <Button
              color="primary"
              className="waves-effect waves-light me-1"
              onClick={handleClickAdd}
              style={{ marginLeft: "auto", background: "#006eb9" }}
            >
              Create Outward
            </Button> */}
          </div>

          <Card>
            <CardBody>
              <TableContainer
                columns={columns || []}
                data={data || []}
                isPagination={false}
                // isGlobalFilter={false}
                iscustomPageSize={false}
                isBordered={false}
                customPageSize={10}
                isLoading={isLoading}
                onSearchInputData={getSearchInputData}
                pageIndexProp={page}
                onPageSizeChange={handlePageSizeChange}
                nextToPage={nextToPages}
                lastToPage={lastToPages}
                previousToPage={previousToPages}
                previousFirstToPage={previousFirstToPages}
                totalCount={totalCount}
                exportData={exportData}
                exportFileName={exportPageData?.fileName}
              />
            </CardBody>
          </Card>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default InstallationApprovalList;
